import { NodeSpec } from 'prosemirror-model'

// from prosemirror-schema-basic

export const horizontalRule: NodeSpec = {
  group: 'block',
  selectable: true,
  draggable: true,
  dragHandle: true,
  parseDOM: [{ tag: 'hr' }],
  toDOM: () => ['hr'],
}
